const validator = {
  document: {
    info: {
      title: 'Validar documento a través de un PDF',
      description: 'Selecciona un documento firmado por Clicksign en .PDF.',
    },
    form: {
      invalid: {
        file_type: 'Este formato no está permitido, por favor utiliza solo archivos .PDF',
        file_size: 'El tamaño del archivo excede el límite permitido de %{file_max_size}mb',
      },
    },
    result: {
      title: 'Resultado',
      validate_at: 'Validación realizada',
      date_time: 'Las fechas y los horarios están en GMT',
      file_hash: 'Hash del archivo validado (SHA256):',
      signed: 'Documento Firmado Electrónicamente por Clicksign.',
      invalid: 'No se pudo validar este archivo.',
      icp_valid: 'Certificado ICP-Brasil válido: Clicksign Gestão de Documentos S.A.',
      more_info: 'Conoce más',
    },
    loading: 'Validando documento',
    resend: 'Validar otro documento',
    print: 'Imprimir',
    lgpd: {
      link: 'Aviso de privacidad conforme a las nuevas leyes locales de protección de datos ',
    },
  },
};

export default validator;
